// src/components/privateRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
	const { isLoggedIn, isLoading } = useAuth();

	if (isLoading) {
		// Show loading state while checking authentication
		return (
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '100vh',
				}}
			>
				<p>Laster...</p>
			</div>
		);
	}

	return isLoggedIn ? children : <Navigate to='/login' />;
};

export default PrivateRoute;
